import moment from 'moment';

import antConfig from '@/ant-config';
import { AppIcon } from '@/react_app/common/AppIcon';
import AppLoader from '@/react_app/common/AppLoader';
import { RefreshHeaderProps } from '@/react_app/components/BillingUsage/Overview/types';

export const DATE_FORMAT_DISPLAY = 'MMM Do, HH:mm';
const LastRefreshHeader = ({ isRefreshing, lastRefreshDate, onSync }: RefreshHeaderProps) => {
	const formattedLastRefreshDate = moment(lastRefreshDate).format(DATE_FORMAT_DISPLAY);
	return (
		<div className="max-w-6xl flex-end--end">
			<div className="pr-2" style={{ color: antConfig.token?.colorTextTertiary }}>
				Last refresh on {formattedLastRefreshDate}
			</div>
			{isRefreshing ? (
				<AppLoader></AppLoader>
			) : (
				<div onClick={onSync} style={{ color: antConfig.token?.colorTextTertiary, cursor: 'pointer' }} className="pb-2">
					<AppIcon name="refresh"></AppIcon>
				</div>
			)}
		</div>
	);
};

export default LastRefreshHeader;
